import * as React from 'react';

import {FieldWithIcon} from 'shells/field-with-icon/field-with-icon';
import {FormattedNumberField} from 'shells/formatted-number-field/formatted-number-field';
import {HashtagIcon} from 'shells/icon';

export const NUMBER_EMPLOYEES_INPUT_FIELD_ID = 'number-of-employees-input-field';

type Props = {
    numberOfEmployees: string | null | undefined;
    onUpdateNumberOfEmployees: (numberOfEmployees?: number | null | undefined) => void;
    isDisabled?: boolean;
};

export function AccountNumberOfEmployeesField(props: Props) {
    const {numberOfEmployees, onUpdateNumberOfEmployees, isDisabled} = props;

    const [employeesInput, setEmployeesInput] = React.useState<number | null | undefined>(
        numberOfEmployees ? parseInt(numberOfEmployees) : null
    );

    const onSaveEmployeesInput = () => {
        if (isDisabled || numberOfEmployees === employeesInput) return;

        onUpdateNumberOfEmployees(employeesInput);
    };

    React.useEffect(() => {
        setEmployeesInput(numberOfEmployees ? parseInt(numberOfEmployees) : null);
    }, [numberOfEmployees]);

    return (
        <FieldWithIcon icon={HashtagIcon}>
            <FormattedNumberField
                formatType='number'
                // @ts-expect-error
                size='small'
                placeholder='0'
                id={NUMBER_EMPLOYEES_INPUT_FIELD_ID}
                value={employeesInput}
                onChange={setEmployeesInput}
                onEnter={onSaveEmployeesInput}
                onBlur={onSaveEmployeesInput}
                clearable={true}
                disabled={isDisabled}
            />
        </FieldWithIcon>
    );
}
